export class Christmas2019EventInfo {
    isActive(date) {
        date ??= new Date;
        return date.getMonth() === 11
            && date.getDate() > 5
            && date.getDate() < 27;
    }

    dispatch() {
        const impl = new Christmas2019Event;
        impl.dispatch();
        return impl;
    }
};

export class Christmas2019Event {
    #propName;
    #headerBg;
    #menuBgs;

    constructor() {
        this.#propName = `msz-christmas-${(new Date).getFullYear()}`;
        this.#headerBg = document.querySelector('.header__background');
        this.#menuBgs = Array.from(document.querySelectorAll('.header__desktop__submenu__background'));

        if(!localStorage.getItem(this.#propName))
            localStorage.setItem(this.#propName, '0');
    }

    changeColour() {
        let count = parseInt(localStorage.getItem(this.#propName));
        document.body.style.setProperty('--header-accent-colour', (count++ % 2) ? 'green' : 'red');
        localStorage.setItem(this.#propName, count.toString());
    }

    dispatch() {
        if(this.#headerBg)
            this.#headerBg.style.transition = 'background-color .4s';

        setTimeout(() => {
            if(this.#headerBg)
                this.#headerBg.style.transition = 'background-color 1s';

            for(const menuBg of this.#menuBgs)
                menuBg.style.transition = 'background-color 1s';
        }, 1000);

        this.changeColour();
        setInterval(this.changeColour, 10000);
    }
};
